/**
 * SocketIOService bridge — receives the real socket from AeThexProvider via setSocket().
 * Components call on*() methods; listeners are registered once the socket is available.
 */

class SocketIOService {
  constructor() {
    this.socket = null;
    this._pending = [];
  }

  setSocket(socket) {
    this.socket = socket;
    for (const { event, callback } of this._pending) {
      this.socket.on(event, callback);
    }
    this._pending = [];
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    } else {
      this._pending.push({ event, callback });
    }
  }

  emit(event, ...args) {
    if (this.socket) this.socket.emit(event, ...args);
  }

  off(event, callback) {
    if (this.socket) this.socket.off(event, callback);
  }

  onNewMessage(cb)            { this.on('new_message', cb); }
  onMessageEdited(cb)         { this.on('message:edited', cb); }
  onMessageDeleted(cb)        { this.on('message:deleted', cb); }
  onMessageReacted(cb)        { this.on('message:reacted', cb); }
  onUsertyping(cb)            { this.on('user_typing', cb); }
  onUserStoppedTyping(cb)     { this.on('user_stopped_typing', cb); }
  onUserStatusChanged(cb)     { this.on('user_status_changed', cb); }
  onPresenceUpdate(cb)        { this.on('presence:online', cb); }
  onVoiceUserJoined(cb)       { this.on('voice:user_joined', cb); }
  onVoiceUserLeft(cb)         { this.on('voice:user_left', cb); }
  onVoiceSignal(cb)           { this.on('voice:signal', cb); }
  onCallOffer(cb)             { this.on('call:offer', cb); }
  onCallAnswer(cb)            { this.on('call:answer', cb); }
  onCallIceCandidate(cb)      { this.on('call:ice-candidate', cb); }
  onCallEnded(cb)             { this.on('call:ended', cb); }
  onCallParticipantJoined(cb) { this.on('call:participant-joined', cb); }
  onCallParticipantLeft(cb)   { this.on('call:participant-left', cb); }

  sendMessage(data)    { this.emit('message:send', data); }
  editMessage(data)    { this.emit('message:edit', data); }
  deleteMessage(data)  { this.emit('message:delete', data); }
  sendReaction(data)   { this.emit('message:react', data); }
  startTyping(data)    { this.emit('user:typing', data); }
  stopTyping(data)     { this.emit('user:stop_typing', data); }
  joinChannel(id)      { this.emit('channel:join', { channelId: id }); }
  leaveChannel(id)     { this.emit('channel:leave', { channelId: id }); }
  setStatus(status)    { this.emit('user:status', { status }); }
}

const socketIOService = new SocketIOService();
export default socketIOService;
